import React, { ReactNode } from 'react';

import ConfirmationPopover from '@mos-cat/confirmation-popover';
import { i18n } from '../../../helpers/i18n';
import { t } from '@lingui/macro';

export interface AddMarriageInfoPopoverProps {
  isPopoverOpen: boolean;
  onPopoverClose?(): void;
  onConfirm?(): void;
  onCancel?(): void;
  children?: ReactNode;
  title?: string;
}

function AddMarriageInfoPopover({
  children,
  title,
  ...restprops
}: AddMarriageInfoPopoverProps) {
  return (
    <ConfirmationPopover
      floating
      title={title || i18n._(t`Изменить сведения о браке`)}
      description={i18n._(t`Все сведения о втором родителе будут потеряны`)}
      acceptText={i18n._(t`Изменить`)}
      cancelText={i18n._(t`Не изменять`)}
      className="AddMarriageInfoPopover"
      {...restprops}
      wrapperClassName="Form__Popover_wrapper"
    >
      {children}
    </ConfirmationPopover>
  );
}

export default AddMarriageInfoPopover;
